<template>
    <section class="blockElement p-0 loginLoader">
        <div class="loginregister">
            <app-language :page="'login'"> </app-language>
        </div>
        <div class="container-fluid">
            <div class="riskWarningMsg d-md-none">
                <small>{{$t('lg_riskWarningMsg')}}</small>
            </div>
            <div class="innerInclude p_login">
                <div class="row">
                    <div class="mobileLogo d-md-none">
                        <router-link :to="'/'" class="green">
                            <img src="../../../../static/fxView/images/fxview_logo.svg" alt="fxView" />
                        </router-link>
                    </div>
                    <div class="col-12 col-md-6 col-xl-4 text-center d-flex vh_100 flex-wrap blueBG beforeBG justify-content-center align-items-center">
                        <div class="w-100">
                            <div class="titleArera Loginlogo">
                                <router-link :to="'/'" class="green">
                                    <img src="../../../../static/fxView/images/fxview_logo_white.svg" alt="fxView" />
                                </router-link>
                            </div>

                            <div class="slider-sec">
                                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active">
                                            <div class="titleArera">
                                                <h2 class="medium mb-5">Multi-Regulated <span class="bold d-block">Award Winning Broker</span></h2>
                                            </div>
                                            <div class="award-sec d-flex flex-wrap justify-content-center">
                                                <div class="award-item text-center mb-4 pb-2">
                                                    <img class="img-fluid mb-1" src="../../../../static/fxView/images/best2021.svg" />
                                                    <h3 class="mb-1 text-white">Best Value Broker</h3>
                                                    <p class="m-0">Forex Expo <span class="d-block">Dubai</span></p>
                                                </div>

                                                <div class="award-item text-center mb-4 pb-2">
                                                    <img class="img-fluid mb-1" src="../../../../static/fxView/images/most2022.svg" />
                                                    <h3 class="mb-1 text-white">Most Trusted Broker</h3>
                                                    <p class="m-0">Ultimate Fintech<span class="d-block">Cyprus</span></p>
                                                </div>

                                                <div class="award-item text-center mb-4 pb-2">
                                                    <img class="img-fluid mb-1" src="../../../../static/fxView/images/best-cfd-2022.svg" />
                                                    <h3 class="mb-1 text-white">Best Global CFD Broker</h3>
                                                    <p class="m-0">Forex Expo<span class="d-block">Dubai</span></p>
                                                </div>

                                                <div class="award-item text-center mb-4 pb-2">
                                                    <img class="img-fluid mb-1" src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
                                                    <h3 class="mb-1 text-white">Best ECN/STP Broker</h3>
                                                    <p class="m-0">UF Awards MEA<span class="d-block">Dubai</span></p>
                                                </div>
                                                <div class="award-item text-center mb-4 pb-2">
                                                    <img class="img-fluid mb-1" src="../../../../static/fxView/images/best-ecn-stp2023.svg" />
                                                    <h3 class="mb-1 text-white">Best Multi Asset Broker</h3>
                                                    <p class="m-0">FAME<span class="d-block">South Africa</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="carousel-item">
                                            <div class="loginNewSection">
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/Spreads.png" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div class="LoginContent text-left" v-html="$t('reg_welcomemsg1')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/Commission.png" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div class="LoginContent text-right" v-html="$t('reg_welcomemsg2')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/TradingTools.png" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div class="LoginContent text-left" v-html="$t('reg_welcomemsg3')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/FastExecution.png" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div class="LoginContent text-right" v-html="$t('reg_welcomemsg4')"></div>
                                                    </div>
                                                </div>
                                                <div class="loginSpreads d-flex">
                                                    <div class="d-flex position-relative InnerLogin">
                                                        <div class="loginIcon">
                                                            <figure>
                                                                <img src="../../../../static/fxView/images/DepositBonus.png" alt="" />
                                                            </figure>
                                                        </div>
                                                        <div class="LoginContent text-left" v-html="$t('reg_welcomemsg5')"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="clearfix"></div>
                                    <ol class="carousel-indicators">
                                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-8 p-0 d-flex vh_100 align-items-center customHeight">
                        <div class="sign_insec">
                            <!--loader - message--->
                            <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                            <!--<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>-->
                            <div>
                                <div class="warningMsg mb-3 p-3" v-if="response_msg != '' && msg_type == 'error'">
                                    <div class="infomsg d-flex align-items-center justify-content-between">
                                        <div class="d-flex w-100 align-items-center">
                                            <p v-html="response_msg">
                                                <feather type="alert-circle"></feather>
                                            </p>
                                        </div>
                                        <feather type="x" @click.prevent="hideFunc()"></feather>
                                    </div>
                                </div>
                                <div class="warningMsg successMsg mb-3 p-3" v-if="response_msg != '' && msg_type == 'success'">
                                    <div class="infomsg d-flex align-items-center justify-content-between">
                                        <div class="d-flex w-100 align-items-center">
                                            <p v-html="response_msg">
                                                <feather type="check"></feather>
                                            </p>
                                        </div>
                                        <feather type="x" @click.prevent="hideFunc()"></feather>
                                    </div>
                                </div>
                            </div>
                            <flash-message></flash-message>
                            <div class="stepForm" v-if="!gAuthenticatorEnabled">
                                <div class="subtitle d-flex w-100">
                                    <h3>{{$t('lg_signin')}}</h3>
                                </div>

                                <div class="form-group field-wrapper">
                                    <input
                                        type="text"
                                        name="email"
                                        v-model="email"
                                        class="float-field form-control"
                                        v-validate="'required|email'"
                                        :class="({ 'is-invalid': submitted && errors.has('email') })"
                                        ref="emailInput"
                                        autocomplete="undefined"
                                        @focus="emailInput"
                                    />
                                    <label for="username" class="float-label">{{$t('lg_emailaddress')}}</label>
                                    <p class="error" v-if="submitted" v-for="error in errors.collect('email')">
                                        <span v-if="error == 'The email field must be a valid email.'">{{$t('lg_EmailfieldValid')}}</span>
                                        <span v-if="error == 'The email field is required.'">{{$t('lg_EmailfieldReq')}}</span>
                                    </p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input
                                        :type="inputtype"
                                        name="Password"
                                        v-model="password"
                                        class="float-field form-control"
                                        v-validate="'required'"
                                        :class="({ 'is-invalid': submitted && errors.has('Password') })"
                                        ref="passwordInput"
                                        v-on:keyup.enter="submit"
                                        autocomplete="undefined"
                                        @focus="passwordInput"
                                    />
                                    <label for="password" class="float-label">{{$t('lg_password')}}</label>
                                    <feather :type="iconType" class="toggle-password" @click.prevent="switchVisibility"></feather>
                                    <p class="error" v-if="submitted" v-for="error in errors.collect('Password')">{{ error }}</p>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton">
                                    <button class="prism_btn btn_sm" v-on:click.prevent="submit()">{{$t('lg_logIn')}}</button>

                                    <div class="forgot_sec">
                                        <router-link :to="'/forgot-password'" class="forgotpassword d-flex align-items-center" @click.native="forgotPasswordEvent"> <feather type="lock" class="mr-1"></feather> {{$t('lg_forgotPassword')}} </router-link>
                                    </div>
                                </div>

                                <div class="mt-4 forgot_sec mb-2 d-flex align-items-center justify-content-between">
                                    <p class="mb-0">{{$t('lg_donthaveaccount')}} <router-link @click.native="signupEvent" :to="'/register'"> {{$t('lg_signuphere')}} </router-link></p>
                                    <!-- <change-entity></change-entity> -->
                                </div>

                                <div class="charlgateMsg border-top pt-2 mt-2">
                                    <small>{{$t('lg_charlgateMsGlobal')}} </small>
                                    <!--  <small v-else>{{$t('lg_charlgateMsEurope')}}</small> -->
                                </div>
                            </div>

                            <div class="stepForm" v-else>
                                <div class="subtitle w-100">
                                    <h3 class="mb-3">{{$t('lg_varify2step')}}</h3>
                                    <p class="mb-4" v-html="$t('googleOtp')"></p>
                                </div>
                                <div class="form-group field-wrapper">
                                    <input placeholder=" " type="text" name="code" v-model="code" class="float-field form-control" v-validate="'required'" :class="{ 'is-invalid': submittedCode && errors.has('code') }" ref="codeInput" />
                                    <label for="username" class="float-label">{{$t('lg_EnterAuthCode')}}</label>
                                    <p class="error" v-for="error in errors.collect('code')">{{ error }}</p>
                                </div>
                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-between align-items-center submitButton">
                                    <button class="prism_btn btn_sm" v-on:click.prevent="submitCode()">{{$t('lg_submit')}}</button>

                                    <div class="forgot_sec">
                                        <a href="#" class="forgotpassword d-flex" @click.prevent="gAuthenticatorEnabled = false"> <feather type="lock" class="mr-1"></feather> {{$t('lg_backLogin')}} </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="fixedBarBottom fullwidth register-page-fixedbar">
			<div class="footPromoLastBar  text-center">
                <p class="" v-html="$t('lg_footerMsz2')"></p>
                <a href="https://fxview.com/static/fxview/pdf/legal-document/Risk-Disclosure-And-Warnings-Notice.pdf" target="_blank">{{$t('lg_riskDisclaimer')}}</a> 
            </div>
		</div> -->
    </section>
</template>
<script>
    var CryptoJS = require("crypto-js");
    const crypto = require("crypto");
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import language from "../shared/language_before_login";
    import { fxViewMixins } from "@/plugins/fxView";
    export default {
        name: "Login",
        mixins: [fxViewMixins],
        data() {
            return {
                pageLoader: false,
                response_msg: "",
                msg_type: "",
                email: "",
                password: "",
                submitted: false,
                showpassword: false,
                iconType: "eye-off",
                inputtype: "password",

                code: "",
                submittedCode: false,
                gAuthenticatorEnabled: false,
            };
        },
        components: {
            appLanguage: language,
        },
        methods: {
            hideFunc() {
                this.response_msg = "";
                this.msg_type = "";
            },
            ...mapActions({
                _runUserLogin: types.RUN_USER_LOGIN,
                _runUserLogin2FA: types.RUN_USER_LOGIN_2FA,
                _runstateLoad: types.RUN_STATE_LOAD,
            }),
            switchVisibility() {
                this.showpassword = !this.showpassword;
                if (this.showpassword) {
                    this.inputtype = "text";
                    this.iconType = "eye";
                } else {
                    this.inputtype = "password";
                    this.iconType = "eye-off";
                }
            },
            submit() {
                const _that = this;
                _that.submitted = true;
                this.$cookies.set("entity", "G", "4m", null, this.$env_var.cookieSaveUrl);
                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                email: _that.email,
                                password: _that.password,
                            },
                            localParams: { parameter: _that },
                        };
                        this.$trackEvent('FXView+Login+Sign+In');
                        _that._runUserLogin(input_json);
                        // if(tradingAccountList.totalRecords > 0) {
                        //     console.log("trading check")
                        //     this.$router.push('/dashboard');
                        // } else {
                        //     this.$router.push('/choose-account');
                        // }
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            // submit() {
            //     const _that = this;
            //     _that.submitted = true;
            //     this.$cookies.set("entity", "G", "4m", null, this.$env_var.cookieSaveUrl);
                
            //     // Validate the form
            //     _that.$validator.validate().then((valid) => {
            //         if (valid) {
            //             let input_json = {
            //                 globalParams: {
            //                     email: _that.email,
            //                     password: _that.password,
            //                 },
            //                 localParams: { parameter: _that },
            //             };

            //             // Trigger login event and login process
            //             this.$trackEvent('FXView+Login+Sign+In');
            //             _that._runUserLogin(input_json).then(response => {
            //                 // Assuming the API response gives you user data, e.g., response.user
            //                 const user = response.user;
                            
            //                 // Example structure: user = { user_id: 100, step: 2 }
            //                 if (user.user_id < 73766 && user.step <= 4) {
            //                     console.log("user.user_id", user.user_id)
            //                     // Redirect to choose-account if conditions are met
            //                     this.$router.push('/choose-account');
            //                 } else if (tradingAccountList.totalRecords > 0) {
            //                     // Redirect to dashboard if there are trading accounts
            //                     this.$router.push('/dashboard');
            //                 } else {
            //                     // Default redirect if none of the above conditions are met
            //                     this.$router.push('/choose-account');
            //                 }
            //             }).catch(error => {
            //                 // Handle login errors
            //                 console.error('Login failed:', error);
            //                 _that.handleValidationErrorAdvanced(_that.errors);
            //             });
            //         } else {
            //             _that.handleValidationErrorAdvanced(_that.errors);
            //         }
            //     });
            // },
            submitCode() {
                const _that = this;
                _that.submittedCode = true;

                const mykey = crypto.createCipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let hashedstr = mykey.update(_that.password, "utf8", "hex");
                hashedstr += mykey.final("hex");

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                google_token: _that.code.toString(),
                                email: _that.email,
                                password: hashedstr,
                            },
                            localParams: { parameter: _that },
                        };
                        _that._runUserLogin2FA(input_json);
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            jsonFunc() {
                let json1 = {
                    key1: "gg",
                    key2: "gfgfg",
                };
                let json2 = {
                    key2: "2",
                    key3: "2",
                };
                let count = 0;
                for (let key in json1) {
                    count++;
                    if (json2[key]) {
                    } else {
                        json2[key] = json1[key];
                    }

                    if (count == Object.keys(json1).length) {
                        //console.log('json2-----',json2)
                    }
                }
            },
            accessTokenQuery(accessToken) {
                const _that = this;
                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                accessToken: accessToken,
                            },
                            localParams: { parameter: _that },
                        };
                        _that._runAstropayAffiliateLogin(input_json);
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            emailInput(){
                this.$trackEvent('FXView+Login+Email');
            },
            passwordInput(){
                this.$trackEvent('FXView+Login+Password');
            },
            forgotPasswordEvent(){
                this.$trackEvent('FXView+Login+Forgot+Password');
            },
            signupEvent(){
                this.$trackEvent('FXView+Login+Register');
            }
        },
        created() {
            this.$trackEvent('FXView+Login+Pageview');
            const params = new URLSearchParams(window.location.search);
            if (params.get("accessToken")) {
                this.accessTokenQuery(params.get("accessToken"));
            }
            // const CryptoJS = require("crypto-js");
            //this.jsonFunc()
            // console.log("created--->", this.$route);
            if ("verify" in this.$route.query) {
                const encyptKey = this.$route.query["verify"];
                const crypto = require("crypto");

                let mykey = crypto.createDecipher("aes-128-cbc", "F*V(I)e^E#1108@3");
                let mystr = mykey.update("ef77c279b79794686dc4d1b41b8c2b91", "hex", "utf8");
                mystr += mykey.final("utf8");
            }
            if (this.$route.query.token) {
                let user = {
                    password: "",
                    email: "",
                    username: "",
                    client_code: "",
                    profile: {},
                    token: this.$route.query.token,
                    loggedIn: true,
                };

                localStorage.setItem("user", btoa(JSON.stringify(user)));
                this._runstateLoad({ globalParams: {}, localParams: { parameter: this, page: "indexVue" } });
            }
            let lastPath = localStorage.getItem("lastPath");
            let temp_token = localStorage.getItem("temp_token");
            if (lastPath && temp_token) {
                localStorage.removeItem("temp_token");
                this._runstateLoad({ globalParams: {}, localParams: { parameter: this, auth: temp_token, path: lastPath } });
            }
            // https://dev.finvasia.com:8083/verifyuser/ef77c279b79794686dc4d1b41b8c2b91

            /*var mykey = CryptoJS.createDecipher('aes-128-cbc', 'mypassword');
            var mystr = mykey.update('34feb914c099df25794bf9ccb85bea72', 'hex', 'utf8')
            mystr += mykey.final('utf8');

            var bytes  = CryptoJS.AES.decrypt("34feb914c099df25794bf9ccb85bea72", 'abc');
            var originalText = bytes.toString(CryptoJS.enc.Utf8);
            console.log(originalText);*/

            /*var bytes = CryptoJS.HmacSHA1("f7412f588099f7f0ba739e71dbc139d735c9d522", "F*V(I)^E#1108@3")
            var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            console.log(decryptedData);*/

            // https://dev.finvasia.com:8083?f7412f588099f7f0ba739e71dbc139d735c9d522
            /*const CryptoJS = require("crypto-js");
            console.log(CryptoJS.HmacSHA1.decrypt("f7412f588099f7f0ba739e71dbc139d735c9d522", "F*V(I)e^E#1108@3"));*/
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/fxView/users/login.vue